/**
 * Role constants for Arkitekt EA
 * @module constants/roles
 */

/** Global user roles */
export const GLOBAL_ROLES = ['viewer', 'editor', 'admin'] as const;
export type GlobalRole = (typeof GLOBAL_ROLES)[number];

/** Space-specific roles */
export const SPACE_ROLES = ['viewer', 'editor', 'admin'] as const;
export type SpaceRole = (typeof SPACE_ROLES)[number];

/** Role hierarchy for authorization checks */
export const ROLE_HIERARCHY: Record<SpaceRole, number> = {
  viewer: 1,
  editor: 2,
  admin: 3,
} as const;

/**
 * Check if a role has at least the required permission level
 */
export function hasMinimumRole(userRole: SpaceRole, requiredRole: SpaceRole): boolean {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}
